"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NodeGuards_1 = require("./NodeGuards");
class NodeLiteralUtils {
    static isProhibitedLiteralNode(literalNode, parentNode) {
        if (NodeGuards_1.NodeGuards.isPropertyNode(parentNode) && !parentNode.computed && parentNode.key === literalNode) {
            return true;
        }
        if (NodeGuards_1.NodeGuards.isImportDeclarationNode(parentNode)) {
            return true;
        }
        return false;
    }
}
exports.NodeLiteralUtils = NodeLiteralUtils;
